<template>
	<div class="contain">
		<img class="imgs" src="../../../assets/c16/howto_01.png" alt="솔닥 비대면진료 자격 대폭 확대 안내(아래글 참고)" />
		<img class="imgs" src="../../../assets/c16/howto_02.png" alt="솔닥 비대면진료 이렇게 이용하세요(아래글 참고)" />
		<img class="imgs" src="../../../assets/c16/howto_03.png" alt="솔닥 비대면진료 이렇게 이용하세요(아래글 참고)" />
		<div class="sr-only">
			<div>
				<h2>솔닥 비대면진료 자격 대폭 확대 안내</h2>
				<span>2023년 12월 15일부터 달라진 비대면진료 시범사업 보완방안을 확인하세요</span>
				<div>
					<span>비대면진료 자격 1</span>
					<h3>휴일과 야간에는 누구나 초진부터 비대면 진료를 받을 수 있어요</h3>
					<ul>
						<li>
							<span>평일</span>
							<strong>오후 6시 ~ 오전 8시까지</strong>
						</li>
						<li>
							<span>휴일</span>
							<strong>토요일 오후 1시~ 일요일 자정까지</strong>
							<span>* 공휴일은 24시간 비대면 진료 가능</span>
						</li>
					</ul>
				</div>
				<div>
					<span>비대면진료 자격 2</span>
					<h3>아래의 경우 언제든 비대면진료를 받을 수 있어요</h3>
					<ul>
						<li>
							솔닥 제휴 병원에서 6개월 이내 직접 방문 진료를 본 이력이 있는 경우
						</li>
						<li>
							주소지가 의료취약지역에 해당하는 경우
							<span>*의료취약지역 대상자 해당 여부는 고객센터에 문의해 주세요.</span>
						</li>
					</ul>
				</div>
			</div>
			<div>
				<h2>솔닥 비대면진료 이렇게 이용하세요</h2>
				<div>
					<span>솔닥 비대면진료 예약</span>
					<h3>솔닥 앱을 통한 비대면진료 예약</h3>
					<ul>
						<li>솔닥 앱에서 진료를 희망하는 증상과 병원 선택 후 비대면 진료를 예약하세요.</li>
					</ul>
				</div>
				<div>
					<span>약 처방 및 수령 안내 1</span>
					<h3>처방약은 가까운 약국에 방문하여 픽업하세요</h3>
					<ul>
						<li>비대면진료 후 솔닥 앱에서 인근 약국을 선택하여 처방전을 전송하세요</li>
						<li>약국에 방문하여 처방약을 수령하세요</li>
					</ul>
					<dl>
						<dt>Q 보습제 MD 등 병원판매 의료기기는 어떻게 수령하나요?</dt>
						<dd>A 병원판매 의료기기의 경우 기존과 같이 택배 배송이 가능합니다.</dd>
					</dl>
				</div>
				<div>
					<span>약 처방 및 수령 안내 2</span>
					<h3>아래 의약품은 비대면진료시 처방이 금지되어 있습니다</h3>
					<ul>
						<li>마약, 향정신성 의약품</li>
						<li>오·남용 우려 의약품 (성기능 치료제 등)</li>
						<li>사후피임약</li>
					</ul>
				</div>
			</div>
			<div>
				<h2>건강한 비대면진료 솔닥과 함께 만들어 가요</h2>
				<p>
					의료 접근성을 높이고 의료진 판단에 근거한 비대면진료가 이루어져 비대면 진료 제도가 건강하게 정착할 수 있도록
					솔닥이 함께 노력하겠습니다.
				</p>
				<ul>
					<li>비대면진료는 대면진료를 보조하는 용도로만 실시해요</li>
					<li>대면 진료를 받았던 의료기관, 거주지 근처 의료기관을 우선 선택해요</li>
					<li>비대면 진료는 의사가 안전하다고 판단한 경우에만 실시해요</li>
					<li>진료, 처방, 방문 등 의사의 판단을 존중해 주세요</li>
					<li>의사가 의료기관 방문을 권유하면 빠른 기간 내 방문해 주세요</li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "c16",
	methods: {}
};
</script>

<style scoped>
.contain {
	width: 100%;
	position: relative;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
	min-width: 800px;
}
.last-img {
	padding-bottom: 150px;
}
.contain .sr-only {
	position: absolute;
	left: -9999px;
	width: 1px;
	height: 1px;
	margin: 0 !important;
	font-size: 0;
	line-height: 0;
	overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/pc_view/contents/c16.vue